import getModalActions from '../../../shared/modals/getModalActions';
import { errorNotification } from '../../../shared/store/notificationActions';
import { fetchingError } from '../../../shared/store/actions';

import {
  fetchSlAdminAccounts as fetchSlAdminAccountsApi,
  importSlAdminAccounts as importSlAdminAccountsApi,
  fetchSlAccounts as fetchSlAccountsApi,
  fetchSlViews as fetchSlViewsApi,
} from '../api';
import { ModalNames } from '../constants';

import {
  FETCH_SL_ADMIN_ACCOUNTS,
  FETCH_SL_ADMIN_ACCOUNTS_SUCCESS,
  FETCH_SL_ADMIN_ACCOUNTS_FAILURE,
  FETCH_SL_ACCOUNTS,
  FETCH_SL_ACCOUNTS_SUCCESS,
  FETCH_SL_ACCOUNTS_FAILURE,
  FETCH_SL_VIEWS,
  FETCH_SL_VIEWS_SUCCESS,
  FETCH_SL_VIEWS_FAILURE,
  FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL,
  FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED,
  IMPORTING_SL_ADMIN_ACCOUNTS,
  IMPORTING_SL_ADMIN_ACCOUNTS_SUCCESS,
  IMPORTING_SL_ADMIN_ACCOUNTS_FAILURE,
} from './types';

import agGridConfig from '../../../agGridConfig';
import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';
import Config from '../../../config';
import columnHeaders from '../xlsxImport/columnHeaders';
import { FIELD_MAPPINGS, MAX_COLUMNS_NUMBER, MIN_COLUMNS_NUMBER } from '../xlsxImport/constants';

export const sharedActions = getActions(adminPageNames.SL_ACCOUNTS, {
  pageTitle: adminPageTitles.SL_ACCOUNTS,
  api: getApi({
    pageTitle: adminPageTitles.SL_ACCOUNTS,
    endpoints: {
      FETCH: Config.endpoints.FETCH_SL_ADMIN_ACCOUNTS,
      INSERT: Config.endpoints.INSERT_SL_ADMIN_ACCOUNT,
      UPDATE: Config.endpoints.UPDATE_SL_ADMIN_ACCOUNT,
      DELETE: Config.endpoints.DELETE_SL_ADMIN_ACCOUNT,
      VALIDATE: Config.endpoints.VALIDATE_SL_ADMIN_ACCOUNT,
      IMPORT: Config.endpoints.IMPORT_SL_ADMIN_ACCOUNTS,
    },
  }),
  sortingField: 'slAccount',
  agGridConfig: agGridConfig.adminBalanceSheetManagementAccount,
  excel: {
    sheetName: 'BSM Account',
    lastColumnLetter: 'D',
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
  },
});

export const fetchSlAdminAccounts = ({ periodName }) => async dispatch => {
  dispatch({
    type: FETCH_SL_ADMIN_ACCOUNTS,
  });
  try {
    const response = await fetchSlAdminAccountsApi(periodName);

    return dispatch({
      type: FETCH_SL_ADMIN_ACCOUNTS_SUCCESS,
      slAdminAccounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_SL_ADMIN_ACCOUNTS_FAILURE,
      });
    }
    throw error;
  }
};

export const importSlAdminAccounts = (SlAdminAccounts, periodName) => async dispatch => {
  dispatch({
    type: IMPORTING_SL_ADMIN_ACCOUNTS,
  });
  try {
    await importSlAdminAccountsApi(SlAdminAccounts, periodName);
    dispatch({
      type: IMPORTING_SL_ADMIN_ACCOUNTS_SUCCESS,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORTING_SL_ADMIN_ACCOUNTS_FAILURE,
    });
  }
};

export const fetchSlAccounts = period => async dispatch => {
  dispatch({
    type: FETCH_SL_ACCOUNTS,
  });
  try {
    const response = await fetchSlAccountsApi(period.name);

    return dispatch({
      type: FETCH_SL_ACCOUNTS_SUCCESS,
      slAccounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_SL_ACCOUNTS_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchSlViews = () => async dispatch => {
  dispatch({
    type: FETCH_SL_VIEWS,
  });
  try {
    const response = await fetchSlViewsApi();

    return dispatch({
      type: FETCH_SL_VIEWS_SUCCESS,
      slViews: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_SL_VIEWS_FAILURE,
      });
    }
    throw error;
  }
};


export const fetchInitialDataForSlAccountsAddAndEditModal = period => async dispatch => {
  dispatch({
    type: FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL,
  });

  await Promise.all([
    dispatch(fetchSlAccounts(period)),
    dispatch(fetchSlViews()),
  ]);

  dispatch({
    type: FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED,
  });
};

export const {
  showAction: showSlAccountsAddAndEdit,
  hideAction: hideSlAccountsAddAndEdit,
} = getModalActions(ModalNames.SlAccountsAddAndEdit);
